(function () {
  'use strict';

  class SunShadowController {
    constructor(panelEl, cesiumViewer) {
      this.panel = panelEl;
      this.viewer = cesiumViewer;
      this.slider = this.panel.querySelector('[data-time-slider]');
      this.timeDisplay = this.panel.querySelector('[data-time-display]');
      this.solsticeBtns = this.panel.querySelectorAll('[data-solstice]');
      this.headline = this.panel.querySelector('[data-insight-headline]');
      this.body = this.panel.querySelector('[data-insight-body]');
      this.dot = this.panel.querySelector('[data-insight-dot]');
      this.currentSolstice = 'winter';

      this.init();
    }

    init() {
      if (!this.slider || !this.viewer) return;
      this.viewer.shadows = true;
      if (typeof Cesium !== 'undefined' && Cesium.ShadowMode) {
        this.viewer.terrainShadows = Cesium.ShadowMode.ENABLED;
      }

      this.slider.addEventListener('input', (e) => this.handleTimeChange(Number(e.target.value)));
      
      this.solsticeBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.solsticeBtns.forEach((b) => { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          this.currentSolstice = btn.dataset.solstice;
          this.handleTimeChange(Number(this.slider.value));
        });
      });

      this.handleTimeChange(Number(this.slider.value));
    }

    getDateFromMinutes(minutes) {
      const year = 2026;
      let month = 11, day = 21;
      if (this.currentSolstice === 'spring') { month = 2; day = 21; }
      else if (this.currentSolstice === 'summer') { month = 5; day = 21; }
      else if (this.currentSolstice === 'autumn') { month = 8; day = 23; }

      const hrs = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return new Date(Date.UTC(year, month, day, hrs - 8, mins));
    }

    handleTimeChange(minutes) {
      const targetDate = this.getDateFromMinutes(minutes);
      if (this.viewer.clock && typeof Cesium !== 'undefined') {
        this.viewer.clock.currentTime = Cesium.JulianDate.fromDate(targetDate);
      }

      const hrsStr = Math.floor(minutes / 60).toString().padStart(2, '0');
      const minsStr = (minutes % 60).toString().padStart(2, '0');
      const timeStr = `${hrsStr}:${minsStr}`;
      
      if (this.timeDisplay) this.timeDisplay.textContent = timeStr;
      this.updatePlainLanguageInsight(timeStr, minutes);
    }

    updatePlainLanguageInsight(timeStr, minutes) {
      if (!this.headline || !this.body || !this.dot) return;

      if (this.currentSolstice === 'winter') {
        if (minutes < 680) {
          this.dot.className = 'ace-status-dot ace-status-dot--warning';
          this.headline.textContent = `冬至 ${timeStr} — 局部遮挡`;
          this.body.innerHTML = `上午主要被东南侧建筑遮挡，约 <strong>11:20</strong> 后遮挡情况明显改善。`;
        } else {
          this.dot.className = 'ace-status-dot ace-status-dot--success';
          this.headline.textContent = `冬至 ${timeStr} — 日照良好`;
          this.body.innerHTML = `楼栋正面获得充沛日照，无主要邻近建筑遮挡。`;
        }
      } else if (this.currentSolstice === 'summer') {
        this.dot.className = 'ace-status-dot ace-status-dot--success';
        this.headline.textContent = `夏至 ${timeStr} — 遮挡极少`;
        this.body.innerHTML = `太阳仰角较高，周边建筑遮挡时间低于 <strong>30 分钟</strong>。`;
      } else {
        this.dot.className = 'ace-status-dot ace-status-dot--info';
        this.headline.textContent = `${this.currentSolstice === 'spring' ? '春分' : '秋分'} ${timeStr} — 日照正常`;
        this.body.innerHTML = `周边遮挡属正常范围，午後西照日受西侧楼栋适度遮挡。`;
      }
    }
  }

  window.GCity = window.GCity || {};
  window.GCity.SunShadowController = SunShadowController;
})();